var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavUsdc = function SvgNavUsdc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NavUsdc_svg__usd-coin-(usdc)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "NavUsdc_svg__Vector",
    d: "M14.0833 14.0833C16.3333 11.8333 16.3333 8.08333 14.0833 5.83333",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "NavUsdc_svg__Vector_2",
    d: "M5.91667 5.91667C3.66667 8.16667 3.66667 11.9167 5.91667 14.1667",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "NavUsdc_svg__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "NavUsdc_svg__Vector_3",
    d: "M8.08333 11.3333C8.08333 12.0833 8.66667 12.6667 9.41667 12.6667H10.8333C11.4167 12.6667 12 12.1667 12 11.5C12 10.75 11.6667 10.5 11.25 10.3333L8.91667 9.5C8.33333 9.41667 8.08333 9.16667 8.08333 8.5C8.08333 7.83333 8.58333 7.33333 9.25 7.33333H10.75C11.5 7.33333 12.0833 7.91667 12.0833 8.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "NavUsdc_svg__Vector_4",
    d: "M10 6.5V13.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "NavUsdc_svg__Vector_5",
    d: "M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor",
    opacity: 0.5
  }))));
};
export default SvgNavUsdc;